if(!customElements.get('price-range')) {
  customElements.define(
    'price-range',
    class PriceRange extends HTMLElement {
      constructor() {
        super();
        this.querySelectorAll('input').forEach((element) => {
          element.addEventListener('input', this.onRangeChange.bind(this));
        });
        this.minLabel = this.querySelector('.value-item.min');
        this.maxLabel = this.querySelector('.value-item.max');
      }
    
      onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);

      }
    
      adjustToValidValues(input) {
        const min = parseInt(input.getAttribute('min'));
        const max = parseInt(input.getAttribute('max'));
        const value = parseInt(input.value);
    
        // Adjust the value if it exceeds min or max
        if (!isNaN(min) && value < min) {
          input.value = min;
        }
        if (!isNaN(max) && value > max) {
          input.value = max;
        }
    
        if(input.dataset.inputType === "min") {
          this.minLabel.querySelector('.value').innerHTML = input.value;
        }
    
        if(input.dataset.inputType === "max") {
          this.maxLabel.querySelector('.value').innerHTML = input.value;
        }
      }
    }
  );
}